export const scopeValidations = {
  searchCategories: [
    {
      type: 'notOnlySymbols',
      message: 'searchCategories.errors.alphanumeric',
    },
  ],
};

export default {
  scopeValidations,
};
